export default class DemoConfiguration {
  constructor(initialState) {
    Object.assign(this, initialState);
  }
}
